import {
  AcceptedFileType,
  FileExtension,
  FileType,
  ValidFileType,
} from "@portal/types/file";

export function removeFileExtension(fileName: string) {
  return fileName.replace(/\.[^/.]+$/, "");
}

export function removeFileExtensionWithoutNumbers(fileName: string) {
  return fileName.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z ]/g, " ");
}

const EXTENSION_KEY_MAPPER: Record<AcceptedFileType, ValidFileType> = {
  [FileExtension.DOC]: FileType.DOC,
  [FileExtension.DOCX]: FileType.DOC,
  [FileExtension.JPG]: FileType.JPG,
  [FileExtension.JPEG]: FileType.JPG,
  [FileExtension.PNG]: FileType.PNG,
  [FileExtension.PDF]: FileType.PDF,
  [FileExtension.XLS]: FileType.XLS,
  [FileExtension.XLSX]: FileType.XLS,
  [FileExtension.EML]: FileType.EML,
};

export const AcceptedFileTypes: Array<AcceptedFileType> = [
  FileExtension.DOC,
  FileExtension.DOCX,
  FileExtension.PDF,
  FileExtension.JPG,
  FileExtension.JPEG,
  FileExtension.PNG,
  FileExtension.XLS,
  FileExtension.XLSX,
  FileExtension.EML,
];

export function getFileExtensionFromName(
  name: string | undefined
): AcceptedFileType {
  if (!name) return "" as AcceptedFileType;

  const lastIndexOfDot = name.lastIndexOf(".");

  return (
    lastIndexOfDot === -1 ? "" : name.substring(lastIndexOfDot).toLowerCase()
  ) as AcceptedFileType;
}

export function getFileTypeFromExtension(
  extension: AcceptedFileType
): ValidFileType {
  return EXTENSION_KEY_MAPPER[extension];
}

export function bytesToSize(bytes?: number): string | undefined {
  const units = ["byte", "kilobyte", "megabyte", "gigabyte", "terabyte"];
  if (!bytes) return undefined;

  const navigatorLocal =
    navigator.languages && navigator.languages.length >= 0
      ? navigator.languages[0]
      : "en-US";
  const unitIndex = Math.max(
    0,
    Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
  );

  return Intl.NumberFormat(navigatorLocal, {
    style: "unit",
    unit: units[unitIndex],
  })
    .format(Math.round(bytes / 1024 ** unitIndex))
    ?.toUpperCase();
}
